export type K12LoginStage = 'callback' | 'session' | 'staff'

const messages: Record<K12LoginStage, string> = {
  callback: 'K12 hesabınız doğrulanamadı. Lütfen K12 üzerinden yeniden giriş yapın.',
  session: 'Hesabınız için oturum açılamadı. Lütfen destek ekibiyle iletişime geçin.',
  staff: 'Öğretmen bilgileriniz alınamadı. Okul ve sınıf yetkilerinizin kontrol edilmesi gerekiyor.',
}

const stageCodes: Record<K12LoginStage, string> = {
  callback: 'K12-DOGRULAMA',
  session: 'K12-OTURUM',
  staff: 'K12-OGRETMEN',
}

export function k12LoginError(stage: K12LoginStage, error?: any) {
  const status = error?.response?.status ?? error?.status
  const body = error?.response?.data ?? error?.data ?? error
  const errorCode = body?.errorCode
  // Only expose diagnostic numbers, never raw responses, codes, tokens or URLs.
  const httpCode = Number.isInteger(status) && status >= 400 && status <= 599 ? status : null
  const serviceCode = /^\d{3,9}$/.test(String(errorCode ?? '')) ? String(errorCode) : null
  return {
    message: status === 0
      ? 'Giriş servisine ulaşılamadı. Bağlantınızı kontrol edip K12 üzerinden yeniden deneyin.'
      : messages[stage],
    reference: [stageCodes[stage], httpCode, serviceCode].filter(Boolean).join('-'),
  }
}
